<template>
  <base-layout v-if="initialized" key="initialized">
    <router-view />
  </base-layout>
  <centred-spinner v-else key="spinner" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CentredSpinner from '@/components/CentredSpinner';
import BaseLayout from '@/views/layouts/BaseLayout';

export default {
  name: 'customer-portal',
  components: {
    CentredSpinner,
    BaseLayout,
  },
  data: () => ({
    initialized: false,
  }),
  computed: mapGetters(['isEmptyLoans']),
  methods: {
    ...mapActions(['getAllLoans']),
    ...mapActions(['getDashboardData']),
  },
  async beforeRouteEnter(
    {
      meta: { skipAuth, skipFull },
    },
    from,
    next,
  ) {
    next(async vm => {
      if (!vm.$auth.isAuthenticated()) {
        if (!(skipAuth || skipFull)) {
          vm.$auth.logOut();
        } else {
          vm.initialized = true;
        }
      } else {
        try {
          await vm.$auth.renewTokens();
          await vm.getAllLoans();
          await vm.getDashboardData();

          if (vm.isEmptyLoans) {
            window.location.href = vm.$env.VUE_APP_APPLICATION_UI_LOGIN_LINK;
            return;
          }

          vm.initialized = true;
        } catch (error) {
          if (error.message === 'There is no loans for this customer') {
            window.location.href = vm.$env.VUE_APP_APPLICATION_UI_LOGIN_LINK;
            return;
          }
          // eslint-disable-next-line no-console
          console.error(error);
          vm.$router.replace({ name: 'unexpectedError' });
        }
      }
      vm.$forceUpdate();
    });
  },
};
</script>
<style lang="sass" scoped></style>
